import bannerAU from "assets/images/banners/gift-cards/individual/au.png";
import bannerEN_CA from "assets/images/banners/gift-cards/individual/en-ca.png";
import bannerFR_CA from "assets/images/banners/gift-cards/individual/fr-ca.png";
import bannerGB from "assets/images/banners/gift-cards/individual/gb.png";
import bannerMobile from "assets/images/banners/gift-cards/individual/mobile.png";
import bannerNZ from "assets/images/banners/gift-cards/individual/nz.png";
import { useTranslation } from "react-i18next";

import { AppDownloadQRCode } from "@/components/gift-cards/app-download-qr-code/app-download-qr-code";

import { useIsArcade } from "@/hooks/useIsArcade";

import { Locale } from "@/types/locale";

import LinkButton from "../../buttons/link-button";
import { SupportedLocale } from "../gift-card-hero-banner/gift-card-hero-banner";
import { localeToGiftCardLink } from "../gift-cards.constants";
import styles from "./gift-card-download-details.module.scss";

export type Props = {
    locale: Locale;
};

const bannerImageByRegion: Record<SupportedLocale, string> = {
    "en-US": "",
    "en-AU": bannerAU.src,
    "en-NZ": bannerNZ.src,
    "en-GB": bannerGB.src,
    "en-CA": bannerEN_CA.src,
    "fr-CA": bannerFR_CA.src,
};

export const GiftCardDownloadDetails: React.FC<Props> = ({ locale }) => {
    const { t } = useTranslation();
    const isArcade = useIsArcade();
    const bannerImage = bannerImageByRegion[locale];

    return isArcade ? (
        <div className={styles.containerArcade}>
            <h2 className={styles.heading}>{t("giftCards.details.heading")}</h2>
            <p className={styles.paragraphArcade}>{t("giftCards.details.content")}</p>
            {localeToGiftCardLink[locale] && (
                <>
                    <div className={styles.appLinkContainer}>
                        <LinkButton
                            kind="black"
                            label={t("giftCards.details.buttonLabel")}
                            size="large"
                            url={localeToGiftCardLink[locale]}
                        />
                    </div>
                    <div className={styles.qrCodeContainer}>
                        <AppDownloadQRCode locale={locale} />
                        <p className={styles.qrCodeText}>{t("giftCards.details.codeLabel")}</p>
                    </div>
                </>
            )}
        </div>
    ) : (
        <div className={styles.container}>
            <div className={styles.backgroundContainer}>
                <div
                    className={styles.backgroundLarge}
                    style={{
                        backgroundImage: `url("${bannerImage}")`,
                    }}
                />
                <div
                    className={styles.backgroundSmall}
                    style={{
                        backgroundImage: `url("${bannerMobile.src}")`,
                    }}
                />
            </div>
            <div className={styles.overlayContainer}>
                <h1 className={styles.heading}>{t("giftCards.details.heading")}</h1>
                <p className={styles.paragraph}>{t("giftCards.details.content")}</p>
                <div className={styles.ctaOne}>
                    <LinkButton
                        kind="black"
                        label={t("giftCards.banner.buttonLabel")}
                        size="regular"
                        url={localeToGiftCardLink[locale]}
                        forceArcade
                    />
                </div>
            </div>
        </div>
    );
};
